import React from 'react';
import useStyles from './styles';
import { GetForm } from './modalForm';
import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon } from '@livable/saas-react-components';
// import { useStore } from 'src/stores';

export const PmSubAccountsModal = observer(() => {
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  // const store = useStore();

  return /*#__PURE__*/React.createElement(SimpleModal, {
    title: t('PM Sub-Accounts settings'),
    trigger: /*#__PURE__*/React.createElement(Button, {
      variant: "actionButton",
      className: classes.menuTrigger
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "arrows"
    })),
    noFooter: true,
    noPadding: true
  }, /*#__PURE__*/React.createElement(GetForm, null));
});